import { useReveal } from "../hooks/useReveal";

const PRANIC_IMG =
  "/images/pranic_healing_background.webp";

const SERVICES = [
  {
    icon: "fa-leaf",
    title: "Stress & Anxiety Relief",
    desc: "Energetic clearing of the solar plexus and ajna — the two centres modern stress most readily congests.",
  },
  {
    icon: "fa-heart-pulse",
    title: "Physical Pain Healing",
    desc: "Localised cleansing and re-energising for migraine, back pain, joint inflammation, and post-surgical recovery.",
  },
  {
    icon: "fa-cloud",
    title: "Emotional Trauma Clearing",
    desc: "Gentle release of grief, fear, and rage that has been parked in the heart and back chakras, often for decades.",
  },
  {
    icon: "fa-handshake-angle",
    title: "Relationship Harmony",
    desc: "Working with the heart and meng-mein to clear resentment patterns and restore the capacity for soft contact.",
  },
  {
    icon: "fa-water",
    title: "Energy Body Cleansing",
    desc: "Full-body sweep of the aura and meridians — a quiet hygienic practice for high-empathy and high-stress lives.",
  },
  {
    icon: "fa-sun",
    title: "Chakra Balancing & Spiritual Growth",
    desc: "Structural work across all eleven major chakras for clarity, integration, and a felt sense of higher purpose.",
  },
];

export default function PranicHealing() {
  const ref = useReveal();
  const goToContact = () => {
    document.getElementById("contact")?.scrollIntoView({ behavior: "smooth", block: "start" });
  };

  return (
    <section
      id="pranic"
      className="section pranic"
      style={{ "--pranic-img": `url(${PRANIC_IMG})` }}
      ref={ref}
      data-testid="pranic-section"
    >
      <div className="container">
        <div className="reveal reveal--up" style={{ maxWidth: 760 }}>
          <span className="eyebrow">The Subtle Medicine</span>
          <h2 className="section-title">What is Pranic Healing — and how it transforms a life.</h2>
          <span className="divider-leaf" style={{ color: "var(--np-secondary)" }}>Prana · Life Force</span>
        </div>

        <div className="reveal reveal--up" style={{ marginTop: 28, maxWidth: 800 }}>
          <p className="section-lead" style={{ marginBottom: 18 }}>
            Pranic Healing is a non-touch, protocol-based system of energy medicine
            systematised by Master Choa Kok Sui. It works directly with the aura and
            chakra system — the subtle architecture that governs how vitality flows
            through the body, the emotions, and the mind. Where a chakra has become
            congested or depleted, the systems it governs reflect the imbalance: as
            pain, as fatigue, as anxiety, as stuck grief.
          </p>
          <p className="section-lead">
            A trained practitioner scans, sweeps, and re-energises — and the body, given
            a clean substrate, returns toward its own intelligence. Most of my clients
            describe their first session as "the quietest I have felt in years." That
            quiet is not a metaphor. It is the nervous system, finally, exhaling.
          </p>
        </div>

        <div className="benefit-grid stagger">
          {SERVICES.map((s, i) => (
            <div
              key={s.title}
              className="benefit reveal reveal--scale"
              role="button"
              tabIndex={0}
              onClick={goToContact}
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  e.preventDefault();
                  goToContact();
                }
              }}
              data-testid={`pranic-benefit-${i}`}
            >
              <div className="benefit__icon">
                <i className={`fa-solid ${s.icon}`}></i>
              </div>
              <h3 className="benefit__title">{s.title}</h3>
              <p className="benefit__desc">{s.desc}</p>
            </div>
          ))}
        </div>

        <p className="pranic__quote reveal reveal--up">
          The body has a language older than thought, and prana is its alphabet. Learn
          to listen, and the body will tell you precisely how to heal it.
        </p>
      </div>
    </section>
  );
}
